import { OBJECT_SCREEN_TAB_SEARCH_PARAM } from '../../../../../components/v2/layout/ObjectScreen/objectScreen.constants';
import useSearchParams from '../../../../../hooks/useSearchParams';
import useOrderBook from '../../../../order-book/hooks/useOrderBook';
import { CatalogUrlFilters } from './catalogUrlFilters.types';

const NON_FILTER_SEARCH_PARAMS = [OBJECT_SCREEN_TAB_SEARCH_PARAM];

export const useCatalogUrlFilters = (): CatalogUrlFilters => {
  const { searchParams } = useSearchParams(undefined, {
    searchParamsToIgnore: NON_FILTER_SEARCH_PARAMS,
  });
  const { customerIds } = useOrderBook();

  return { filters: searchParams, customerIds };
};
